import NotificationAlert from 'react-notification-alert'
import axios from 'axios'
import {
  ADD_PRODUCT_SUBMIT,
  CLEAR_CURRENT_SUBMIT,
  DELETE_PRODUCT_SUBMIT,
  EDIT_PRODUCT_SUBMIT,
  FILTER_PRODUCTS_SUBMIT,
  GET_PRODUCTS_SUBMIT,
  SET_CURRENT_SUBMIT,
  SET_UPDATE_SUBMIT,
  LOAD_IMAGES_SUBMIT,
  SET_RESETTING_SUBMIT,
} from 'context/types'
import React, { useContext, useReducer, useRef } from 'react'
import AuthContext from 'context/auth/authContext'
import SubmitContext from './submitContext'
import SubmitReducer from './submitReducer'
import { PropTypes } from 'prop-types'
import { loadProducts } from 'context/Utilities'
import {
  getCheesePackage,
  updateCheesePackage,
} from 'views/Cheese/CheesePackage'
import { getEggsPackage, updateEggsPackage } from 'views/Eggs/EggsPackage'
import {
  getLegumesPackage,
  updateLegumesPackage,
} from 'views/Legumes/Utilities'
import {
  getCannedFishPackage,
  updateCannedFishPackage,
} from 'views/CannedFish/CannedFish'
import {
  getWholeGrainsPackage,
  updateWholeGrainsPackage,
} from 'views/WholeGrains/Utilities'
import {
  getFatReduceMilkPackage,
  updateFatReduceMilkPackage,
} from 'views/Milk/FatReducedMilk/FatReducedMilk'
import {
  getWholeMilkPackage,
  updateWholeMilkPackage,
} from 'views/Milk/WholeMilk/WholeMilk'
import { getJuicePackage, updateJuicePackage } from 'views/Juices/JuicePackage'
import {
  getFrozenVegFruitsPackage,
  updateFrozenVegFruitsPackage,
} from 'views/FruitsAndVegs/FrozenVegsFruits/FrozenVegsFruits'
import {
  getCannedVegFruitsPackage,
  updateCannedVegFruitsPackage,
} from 'views/FruitsAndVegs/CannedVegsFruits/CannedVegsFruits'
import {
  getDriedFruitsPackage,
  updateDriedFruitsPackage,
} from 'views/FruitsAndVegs/DriedFruits/DriedFruits'
import {
  getInfantFruitsAndVegsPackage,
  updateInfantFruitsAndVegsPackage,
} from 'views/Infant/FruitsAndVegs/InfantFruitsAndVegs'
import {
  getInfantMeatsPackage,
  updateInfantMeatsPackage,
} from 'views/Infant/Meats/InfantMeats'
import {
  getBSCornTortillaPackage,
  updateBSCornTortillaPackage,
} from 'views/BSWholeGrains/CornTortilla/CornTortilla'
import {
  getBSWheatTortillaPackage,
  updateBSWheatTortillaPackage,
} from 'views/BSWholeGrains/WheatTortilla/WheatTortilla'
import {
  getBSWheatPastaPackage,
  updateBSWheatPastaPackage,
} from 'views/BSWholeGrains/WheatPasta/Utilities'
import {
  getPlantMilkPackage,
  updatePlantMilkPackage,
} from 'views/BrandSpecific/PlantMilk/Utilities'
import { getYogurtPackage, updateYogurtPackage } from 'views/Yogurt/Utilities'
import { getTofuPackage, updateTofuPackage } from 'views/Tofu/Utilities'
import {
  getBSInfantMeatsPackage,
  updateBSInfantMeatsPackage,
} from 'views/BrandSpecific/Infant/Meats/Utilities'
import {
  getBSInfantCerealPackage,
  updateBSInfantCerealPackage,
} from 'views/BrandSpecific/Infant/Cereal/Utilities'
import {
  getBSInfantFruitsAndVegsPackage,
  updateBSInfantFruitsAndVegsPackage,
} from 'views/BrandSpecific/Infant/FruitsAndVegs/Utiliites'
import { getBreakfastCerealPackage } from 'views/BrandSpecific/BreakfastCereal/BreakfastCereal/Utilities'
import { getInstantOatmealPackage } from 'views/BrandSpecific/BreakfastCereal/InstantOatmeal/Utilities'
import {
  getRFIInfantMeatsPackage,
  updateRFIInfantMeatsPackage,
} from 'views/BrandSpecific/RFIInfant/Meats/Utilities'
import {
  getRFIInfantFruitsAndVegsPackage,
  updateRFIInfantFruitsAndVegsPackage,
} from 'views/BrandSpecific/RFIInfant/FruitsAndVegs/Utiliites'
import {
  getPlantYogurtPackage,
  updatePlantYogurtPackage,
} from 'views/BrandSpecific/PlantYogurt/Utilities'
import {
  getPlantCheesePackage,
  updatePlantCheesePackage,
} from 'views/BrandSpecific/PlantCheese/Utilities'
import {
  getNutSeedButtersPackage,
  updateNutSeedButtersPackage,
} from 'views/BrandSpecific/NutSeedButters/Utilities'
import {
  getBSWholeWheatBagelsPackage,
  updateBSWholeWheatBagelsPackage,
} from 'views/BrandSpecific/WholeGrains/BSWholeWheatBagels/Utilities'
import {
  getBSQuinoaPackage,
  updateBSQuinoaPackage,
} from 'views/BrandSpecific/WholeGrains/BSQuinoa/Utilities'
import {
  getBSWholeWheatEnglishMuffinsPackage,
  updateBSWholeWheatEnglishMuffinsPackage,
} from 'views/BrandSpecific/WholeGrains/BSWholeWheatEnglishMuffins/Utilities'
import {
  getBSWholeWheatNaanPackage,
  updateBSWholeWheatNaanPackage,
} from 'views/BrandSpecific/WholeGrains/BSWholeWheatNaan/Utilities'
import {
  getBSWholeWheatPitaBreadPackage,
  updateBSWholeWheatPitaBreadPackage,
} from 'views/BrandSpecific/WholeGrains/BSWholeWheatPitaBread/Utilities'
import {
  getBSWildRicePackage,
  updateBSWildRicePackage,
} from 'views/BrandSpecific/WholeGrains/BSWildRice/Utilities'
import {
  getBSCornMasaFlourPackage,
  updateBSCornMasaFlourPackage,
} from 'views/BrandSpecific/WholeGrains/BSCornMasaFlour/Utilities'
import {
  getBSCornmealPackage,
  updateBSCornmealPackage,
} from 'views/BrandSpecific/WholeGrains/BSCornmeal/Utilities'
import {
  getBSOatsOatmealPackage,
  updateBSOatsOatmealPackage,
} from 'views/BrandSpecific/WholeGrains/BSOatsOatmeal/Utilities'
import {
  getWWBagelsPackage,
  updateWWBagelsPackage,
} from 'views/WWBagels/Utilities'

import {
  getWWMuffinsPackage,
  updateWWMuffinsPackage,
} from 'views/WWMuffins/Utilities'

import {
  getWWPitaBreadPackage,
  updateWWPitaBreadPackage,
} from 'views/WWPitaBread/Utilities'

import {
  getWGCornmealPackage,
  updateWGCornmealPackage,
} from 'views/WGCornmeal/Utilities'

import {
  getCornMasaFlourPackage,
  updateCornMasaFlourPackage,
} from 'views/CornMasaFlour/Utilities'

import {
  getCornTortillaPackage,
  updateCornTortillaPackage,
} from 'views/WholeGrains/CornTortilla/CornTortilla'
import {
  getWheatTortillaPackage,
  updateWheatTortillaPackage,
} from 'views/WholeGrains/WheatTortilla/WheatTortilla'
import {
  getWheatPastaPackage,
  updateWheatPastaPackage,
} from 'views/WholeGrains/WheatPasta/Utilities'

const apiUrl = window.config.apiUrl
const SubmitState = ({ children }) => {
  const initialState = {
    products: [],
    filtered: null,
    current: null,
    updating: false,
    resetting: false,
  }

  const [state, dispatch] = useReducer(SubmitReducer, initialState)

  const authContext = useContext(AuthContext)
  const { user, timeout } = authContext

  const notificationAlert = useRef()
  const notifyExistingUPC = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>UPC already exists. Product not added.</h5>
        </div>
      ),
      type: 'danger',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 6,
    }
    notificationAlert.current.notificationAlert(options)
  }

  // Get unsubmitted products based on vendor's id
  const getVendorProducts = async VendorId => {
    console.log('getVendorProducts called')
    try {
      await axios
        .get(`${apiUrl}/products/vendorstatus/${VendorId}/0`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          loadProducts(products, GET_PRODUCTS_SUBMIT, dispatch)
        })
    } catch (err) {
      if (err?.response?.status === 401) {
        timeout()
      }
      console.log('Get Products Error: ', err.response)
    }
  }

  // Get unsubmitted products based on vendor's id
  const getContactProducts = async ContactId => {
    console.log('getContactProducts called')
    console.log('contactId: ' + ContactId)
    console.log('apiUrl: ' + apiUrl)
    try {
      await axios
        .get(`${apiUrl}/products/contactstatus/${ContactId}/0`)
        .then(response => JSON.parse(response.data.result))
        .then(products => {
          loadProducts(products, GET_PRODUCTS_SUBMIT, dispatch)
        })
    } catch (err) {
      if (err?.response?.status === 401) {
        timeout()
      }
      console.log('Get Contact Products Error: ', err.response)
    }
  }

  // Delete Product based on the product's UPC
  const deleteProduct = async (product, UPC) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    let url = null
    switch (product?.fkCategory) {
      case '00':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/brandspecific/plantbasedyogurt/upc/${UPC}`
            break
          case '002':
            url = `${apiUrl}/products/brandspecific/plantbasedcheese/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/brandspecific/nutandseedbutters/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '02':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/cheese/upc/${UPC}`
            break
          case '004':
            url = `${apiUrl}/products/tofu/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '03':
        url = `${apiUrl}/products/eggs/upc/${UPC}`
        break
      case '05':
        switch (product?.fkSubCategory) {
          case '001BC':
            url = `${apiUrl}/products/bsbreakfastcereal/breakfastcereal/upc/${UPC}`
            break
          case '001IO':
            url = `${apiUrl}/products/bsbreakfastcereal/instantoatmeal/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '06':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/legumes/Peanut Butter/upc/${UPC}`
            break
          case '002':
            url = `${apiUrl}/products/legumes/Dry Beans, Peas, Lentils/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/legumes/Canned Mature Beans/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '08':
        url = `${apiUrl}/products/cannedfish/upc/${UPC}`
        break
      case '09':
        switch (product?.fkSubCategory) {
          case '001BS':
            url = `${apiUrl}/products/brandspecific/infant/cereal/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '12':
        switch (product?.fkSubCategory) {
          case '001':
          case '002':
          case '003':
          case '101':
          case '102':
          case '103':
            url = `${apiUrl}/products/infant/fruitsandvegetables/upc/${UPC}`
            break
          case '001BS':
          case '002BS':
          case '003BS':
          case '101BS':
          case '102BS':
          case '103BS':
            url = `${apiUrl}/products/brandspecific/infant/fruitsandvegetables/upc/${UPC}`
            break
          case '001RFI':
          case '002RFI':
          case '003RFI':
          case '101RFI':
          case '102RFI':
          case '103RFI':
            url = `${apiUrl}/products/brandspecific/rfi/infant/fruitsandvegetables/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '13':
        switch (product?.fkSubCategory) {
          case '001':
          case '101':
            url = `${apiUrl}/products/infant/meats/upc/${UPC}`
            break
          case '001BS':
          case '101BS':
            url = `${apiUrl}/products/brandspecific/infant/meats/upc/${UPC}`
            break
          case '001RFI':
          case '101RFI':
            url = `${apiUrl}/products/brandspecific/rfi/infant/meats/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '16':
        switch (product?.fkSubCategory) {
          case '001':
            url = `${apiUrl}/products/wholegrains/Whole Grain Bread/upc/${UPC}`
            break
          case '003':
            url = `${apiUrl}/products/wholegrains/Brown Rice/upc/${UPC}`
            break
          case '004':
            url = `${apiUrl}/products/wholegrains/Bulgur/upc/${UPC}`
            break
          case '005':
            url = `${apiUrl}/products/wholegrains/Oats or Oatmeal/upc/${UPC}`
            break
          case '005BS':
            url = `${apiUrl}/products/brandspecific/oatsoatmeal/upc/${UPC}`
            break
          case '006':
            url = `${apiUrl}/products/wholegrains/Barley/upc/${UPC}`
            break
          case '007':
            url = `${apiUrl}/products/wholegrains/corntortilla/upc/${UPC}`
            break
          case '007BS':
            url = `${apiUrl}/products/bswholegrains/corntortilla/upc/${UPC}`
            break
          case '008':
            url = `${apiUrl}/products/wholegrains/wheattortilla/upc/${UPC}`
            break
          case '008BS':
            url = `${apiUrl}/products/bswholegrains/wheattortilla/upc/${UPC}`
            break
          case '009':
            url = `${apiUrl}/products/wholegrains/wheatpasta/upc/${UPC}`
            break
          case '009BS':
            url = `${apiUrl}/products/bswholegrains/wheatpasta/upc/${UPC}`
            break
          case '010BS':
            url = `${apiUrl}/products/brandspecific/wholewheatbagels/upc/${UPC}`
            break
          case '011BS':
            url = `${apiUrl}/products/brandspecific/wholewheatenglishmuffins/upc/${UPC}`
            break
          case '012BS':
            url = `${apiUrl}/products/brandspecific/wholewheatpitabread/upc/${UPC}`
            break
          case '010':
            url = `${apiUrl}/products/wholewheatbagels/upc/${UPC}`
            break
          case '011':
            url = `${apiUrl}/products/wholewheatmuffins/upc/${UPC}`
            break
          case '012':
            url = `${apiUrl}/products/wholewheatpitabread/upc/${UPC}`
            break
          case '013':
            url = `${apiUrl}/products/brandspecific/wholewheatnaan/upc/${UPC}`
            break
          case '014':
            url = `${apiUrl}/products/brandspecific/quinoa/upc/${UPC}`
            break
          case '015':
            url = `${apiUrl}/products/brandspecific/wildrice/upc/${UPC}`
            break
          case '016BS':
            url = `${apiUrl}/products/brandspecific/cornmasaflour/upc/${UPC}`
            break
          case '017BS':
            url = `${apiUrl}/products/brandspecific/cornmeal/upc/${UPC}`
            break
          case '016':
            url = `${apiUrl}/products/cornmasaflour/upc/${UPC}`
            break
          case '017':
            url = `${apiUrl}/products/wholegraincornmeal/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '50':
        switch (product?.fkSubCategory) {
          case '001':
          case '002':
            url = `${apiUrl}/products/yogurt/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '51':
        url = `${apiUrl}/products/milk/Whole Milk/upc/${UPC}`
        break
      case '52':
        switch (product?.fkSubCategory) {
          case '002':
          case '004':
          case '006':
          case '012':
          case '014':
            url = `${apiUrl}/products/milk/Reduced Fat/upc/${UPC}`
            break
          case '011':
            url = `${apiUrl}/products/plantmilk/upc/${UPC}`
            break
          default:
            break
        }
        break
      case '54':
        url = `${apiUrl}/products/juice/upc/${UPC}`
        break
      case '19':
        switch (product?.fkSubCategory) {
          case '001FF':
          case '001FV':
            url = `${apiUrl}/products/fruitsandvegetables/${product?.FrozenProductType}/frozen/upc/${UPC}`
            break
          case '001CF':
          case '001CV':
            url = `${apiUrl}/products/fruitsandvegetables/${product?.CannedProductType}/canned/upc/${UPC}`
            break
          case '004':
            url = `${apiUrl}/products/legumes/Dried Fruits/upc/${UPC}`
            break
          default:
        }
        break
      default:
        console.log('fkCategory is: ' + product?.fkCategory)
    }
    try {
      console.log('config is: ' + JSON.stringify(config))
      await axios.delete(`${apiUrl}/products/image/${product.pkProduct}`)
      await axios.delete(url, config)
      dispatch({ type: DELETE_PRODUCT_SUBMIT, payload: product.UPC })
      if (product.UPC === state.current.UPC) {
        dispatch({ type: CLEAR_CURRENT_SUBMIT })
      }
      console.log('Product successfully deleted')
    } catch (err) {
      console.log('Delete Product Error: ', JSON.stringify(err))
    }
  }

  // Set Current Product
  const setCurrent = currentProduct => {
    dispatch({ type: SET_CURRENT_SUBMIT, payload: currentProduct })
  }

  // Clear Current Product
  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT_SUBMIT, payload: {} })
  }

  // Edit Current Product
  const editCurrent = UPC => {
    dispatch({ type: EDIT_PRODUCT_SUBMIT, payload: UPC })
  }

  const productURL = `${apiUrl}/products`

  const UPCE_to_UPCA = UPC => {
    if (UPC.length !== 8) {
      return UPC
    }
    const checkDigit = UPC.charAt(6)
    switch (checkDigit) {
      case '0':
      case '1':
      case '2': {
        UPC =
          UPC.substring(0, 3) +
          checkDigit +
          '0000' +
          UPC.substring(3, 6) +
          UPC.charAt(7)
        break
      }
      case '3': {
        UPC =
          UPC.substring(0, 4) + '00000' + UPC.substring(4, 6) + UPC.charAt(7)
        break
      }
      case '4': {
        UPC = UPC.substring(0, 5) + '00000' + UPC.charAt(6) + UPC.charAt(7)
        break
      }
      case '5':
      case '6':
      case '7':
      case '8':
      case '9': {
        UPC = UPC.substring(0, 6) + '0000' + checkDigit + UPC.charAt(7)
        break
      }
      default:
        break
    }
    return UPC
  }

  const addProductDescription = async newProduct => {
    console.log(user)
    const date = new Date()
    const newDescription = {
      fkCategory: newProduct.category || newProduct.fkCategory,
      fkSubCategory: newProduct.subCategory || newProduct.fkSubCategory,
      UPC: newProduct.UPC,
      comments: null,
      SubmissionDate:
        date.getFullYear() +
        '-' +
        ('0' + (date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + date.getDate()).slice(-2) +
        'T' +
        ('0' + date.getHours()).slice(-2) +
        ':' +
        ('0' + date.getMinutes()).slice(-2) +
        ':' +
        ('0' + date.getSeconds()).slice(-2),
      activeDate: '1753-01-01T12:00:00',
      deActiveDate: '9999-12-31T23:59:59',
      IsBroadband: newProduct.IsBroadband,
      fkApprovalStatus: newProduct.fkApprovalStatus || 0,
      fkvendor: user.fkVendor,
      brandName: newProduct.brandName || newProduct.BrandName,
      productName: newProduct.productName || newProduct.ProductName,
      Manufacturer: newProduct.Manufacturer,
      distbInCA: newProduct.distbInCA || newProduct.DistbInCA,
      RetailPrice:
        (Math.round(newProduct.RetailPrice * 100) / 100).toFixed(2) ||
        (Math.round(newProduct.RetailPrice * 100) / 100).toFixed(2),
      FederalNutrition: newProduct.FederalNutrition,
      ReviewerDescription: newProduct.ReviewerDescription,
      fkSubmitter: newProduct.fkSubmitter || user.pkContact,
      ReviewOneFollowUp: false,
      ReviewTwoFollowUp: false,
    }
    const config = { headers: { 'Content-Type': 'application/json' } }

    await axios
      .post(`${productURL}/addnewproduct`, newDescription, config)
      .then(response => {
        console.log(
          'New product description data is: ' + JSON.stringify(response.data)
        )
        newDescription.pkProduct = parseInt(response.data.message)
      })

    return newDescription
  }

  const updateProductDescription = async newProduct => {
    newProduct.RetailPrice =
      (Math.round(newProduct.RetailPrice * 100) / 100).toFixed(2) ||
      (Math.round(newProduct.RetailPrice * 100) / 100).toFixed(2)
    const config = { headers: { 'Content-Type': 'application/json' } }
    await axios
      .put(`${productURL}/${newProduct.UPC}`, newProduct, config)
      .then(response => {
        console.log(
          'Updated product description is: ' +
            JSON.stringify(response.config.data)
        )
        return JSON.parse(response.config.data)
      })
  }

  const addProductPackage = async (
    getProductPackage,
    productType,
    newProduct
  ) => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    const newProductPackage = getProductPackage(newProduct)

    await axios
      .post(`${productURL}/${productType}`, newProductPackage, config)
      .then(response => {
        console.log(
          'New product package data is: ' + JSON.stringify(response.data)
        )
      })

    return newProductPackage
  }

  const updateProductPackage = async (
    updateProductPackage,
    productType,
    newProduct
  ) => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    const newProductPackage = updateProductPackage(newProduct)

    await axios
      .put(`${productURL}/${productType}`, newProductPackage, config)
      .then(response => {
        console.log(
          'Updated product package data is: ' + JSON.stringify(response.data)
        )
      })
  }

  const addProductImages = async (pkProduct, images) => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    if (images) {
      for await (const [index, image] of images.entries()) {
        console.log('image is: ' + image)
        console.log('index is: ' + index)
        const newImage = {
          fkProduct: pkProduct,
          ImageName: image.ImageName,
          ImageType: image.ImageType,
          ProdImg: image.ProdImg,
        }
        console.log('Firing ' + newImage.ImageName)
        await axios
          .post(`${productURL}/image`, newImage, config)
          .then(async response => {
            console.log('response.data for ' + newImage.ImageName)
            console.log(response.data)
            newImage.pkProductIMG = parseInt(response.data.message)
            images[index] = newImage
          })
          .catch(error => {
            console.log(error)
          })
      }
    }

    console.log('images is: ' + JSON.stringify(images))
    return images
  }

  const loadProductImages = async pkProduct => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    await axios
      .get(`${productURL}/image/${pkProduct}`, config)
      .then(response => {
        if (response.data.statusCode === 200) {
          const images = JSON.parse(response.data.result)
          while (images.length < 4) {
            console.log('adding image')
            images.push({
              fkProduct: 0,
              pkProductImage: 0,
              ImageName: '',
              ImageType: '',
              ProdImg: '',
            })
          }

          dispatch({
            type: LOAD_IMAGES_SUBMIT,
            payload: images,
          })
        }
      })
  }

  const updateProductImages = async images => {
    const config = { headers: { 'Content-Type': 'application/json' } }
    console.log('images1 is: ' + JSON.stringify(images))

    if (images) {
      let callArray = []
      images.forEach(image => {
        callArray.push(
          axios
            .put(`${productURL}/image`, image, config)
            .then(response => {
              if (response.data.statusCode === 200) {
                console.log('Updated image successful')
              }
            })
            .catch(error => {
              console.log(error)
            })
        )
      })
      Promise.all(callArray)
    }
    console.log('images2 is: ' + JSON.stringify(images))
    return images
  }

  const deleteProductImages = async images => {
    images.forEach(image => {
      axios.delete(
        `${apiUrl}/products/image/${image.fkProduct}/${image.pkProductIMG}`
      )
    })
  }

  // Check UPC. Add product if UPC does not already exist.
  const checkUPCAddProduct = async newProduct => {
    const convertedUPC = UPCE_to_UPCA(newProduct.UPC)

    addProduct(newProduct)
  }

  // Add Product
  const addProduct = async newProduct => {
    try {
      console.log(
        'JSON.stringify(newProduct) before addProduct is: ' +
          JSON.stringify(newProduct)
      )
      if (newProduct.UPC.length === 8) {
        newProduct.UPC = UPCE_to_UPCA(newProduct.UPC)
      }
      const newProductDescription = await addProductDescription(newProduct)

      let newProductPackage = null
      let category
      let subCategory

      newProduct.category
        ? (category = newProduct.category)
        : (category = newProduct.fkCategory)
      newProduct.subCategory
        ? (subCategory = newProduct.subCategory)
        : (subCategory = newProduct.fkSubCategory)

      switch (category) {
        case '00':
          switch (subCategory) {
            case '001':
              newProductPackage = await addProductPackage(
                getPlantYogurtPackage,
                'brandspecific/plantbasedyogurt',
                newProduct
              )
              break
            case '002':
              newProductPackage = await addProductPackage(
                getPlantCheesePackage,
                'brandspecific/plantbasedcheese',
                newProduct
              )
              break
            case '003':
              newProductPackage = await addProductPackage(
                getNutSeedButtersPackage,
                'brandspecific/nutandseedbutters',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '02':
          switch (subCategory) {
            case '001':
              newProductPackage = await addProductPackage(
                getCheesePackage,
                'cheese',
                newProduct
              )
              break
            case '004':
              newProductPackage = await addProductPackage(
                getTofuPackage,
                'tofu',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '03':
          newProductPackage = await addProductPackage(
            getEggsPackage,
            'eggs',
            newProduct
          )
          break
        case '05':
          switch (subCategory) {
            case '001BC':
              newProductPackage = await addProductPackage(
                getBreakfastCerealPackage,
                'bsbreakfastcereal/breakfastcereal',
                newProduct
              )
              break
            case '001IO':
              newProductPackage = await addProductPackage(
                getInstantOatmealPackage,
                'bsbreakfastcereal/instantoatmeal',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '06':
          newProductPackage = await addProductPackage(
            getLegumesPackage(subCategory),
            'legumes',
            newProduct
          )
          break
        case '08':
          newProductPackage = await addProductPackage(
            getCannedFishPackage,
            'cannedfish',
            newProduct
          )
          break
        case '09':
          switch (subCategory) {
            case '001BS':
              newProductPackage = await addProductPackage(
                getBSInfantCerealPackage,
                'brandspecific/infant/cereal',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '12':
          switch (subCategory) {
            case '001':
            case '002':
            case '003':
            case '101':
            case '102':
            case '103':
              newProductPackage = await addProductPackage(
                getInfantFruitsAndVegsPackage,
                'infant/fruitsandvegetables',
                newProduct
              )
              break
            case '001BS':
            case '002BS':
            case '003BS':
            case '101BS':
            case '102BS':
            case '103BS':
              newProductPackage = await addProductPackage(
                getBSInfantFruitsAndVegsPackage,
                'brandspecific/infant/fruitsandvegetables',
                newProduct
              )
              break
            case '001RFI':
            case '002RFI':
            case '003RFI':
            case '101RFI':
            case '102RFI':
            case '103RFI':
              newProductPackage = await addProductPackage(
                getRFIInfantFruitsAndVegsPackage,
                'brandspecific/rfi/infant/fruitsandvegetables',
                newProduct
              )
              break

            default:
              break
          }
          break
        case '13':
          switch (subCategory) {
            case '001':
            case '101':
              newProductPackage = await addProductPackage(
                getInfantMeatsPackage,
                'infant/meats',
                newProduct
              )
              break
            case '001BS':
            case '101BS':
              newProductPackage = await addProductPackage(
                getBSInfantMeatsPackage,
                'brandspecific/infant/meats',
                newProduct
              )
              break
            case '001RFI':
            case '101RFI':
              newProductPackage = await addProductPackage(
                getRFIInfantMeatsPackage,
                'brandspecific/rfi/infant/meats',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '16':
          switch (subCategory) {
            case '001':
            case '003':
            case '004':
            case '005':
            case '006':
              newProductPackage = await addProductPackage(
                getWholeGrainsPackage(subCategory),
                'wholegrains',
                newProduct
              )
              break
            case '005BS':
              newProductPackage = await addProductPackage(
                getBSOatsOatmealPackage,
                'brandspecific/oatsoatmeal',
                newProduct
              )
              break
            case '007':
              newProductPackage = await addProductPackage(
                getCornTortillaPackage,
                'wholegrains/corntortilla',
                newProduct
              )
              break
            case '007BS':
              newProductPackage = await addProductPackage(
                getBSCornTortillaPackage,
                'bswholegrains/corntortilla',
                newProduct
              )
              break
            case '008':
              newProductPackage = await addProductPackage(
                getWheatTortillaPackage,
                'wholegrains/wheattortilla',
                newProduct
              )
              break
            case '008BS':
              newProductPackage = await addProductPackage(
                getBSWheatTortillaPackage,
                'bswholegrains/wheattortilla',
                newProduct
              )
              break
            case '009':
              newProductPackage = await addProductPackage(
                getWheatPastaPackage,
                'wholegrains/wheatpasta',
                newProduct
              )
              break
            case '009BS':
              newProductPackage = await addProductPackage(
                getBSWheatPastaPackage,
                'bswholegrains/wheatpasta',
                newProduct
              )
              break
            case '010':
              newProductPackage = await addProductPackage(
                getWWBagelsPackage,
                'wholewheatbagels',
                newProduct
              )
              break
            case '011':
              newProductPackage = await addProductPackage(
                getWWMuffinsPackage,
                'wholewheatmuffins',
                newProduct
              )
              break
            case '012':
              newProductPackage = await addProductPackage(
                getWWPitaBreadPackage,
                'wholewheatpitabread',
                newProduct
              )
              break
            case '010BS':
              newProductPackage = await addProductPackage(
                getBSWholeWheatBagelsPackage,
                'brandspecific/wholewheatbagels',
                newProduct
              )
              break
            case '011BS':
              newProductPackage = await addProductPackage(
                getBSWholeWheatEnglishMuffinsPackage,
                'brandspecific/wholewheatenglishmuffins',
                newProduct
              )
              break
            case '012BS':
              newProductPackage = await addProductPackage(
                getBSWholeWheatPitaBreadPackage,
                'brandspecific/wholewheatpitabread',
                newProduct
              )
              break
            case '013':
              newProductPackage = await addProductPackage(
                getBSWholeWheatNaanPackage,
                'brandspecific/wholewheatnaan',
                newProduct
              )
              break
            case '014':
              newProductPackage = await addProductPackage(
                getBSQuinoaPackage,
                'brandspecific/quinoa',
                newProduct
              )
              break
            case '015':
              newProductPackage = await addProductPackage(
                getBSWildRicePackage,
                'brandspecific/wildrice',
                newProduct
              )
              break
            case '016':
              newProductPackage = await addProductPackage(
                getCornMasaFlourPackage,
                'cornmasaflour',
                newProduct
              )
              break
            case '017':
              newProductPackage = await addProductPackage(
                getWGCornmealPackage,
                'wholegraincornmeal',
                newProduct
              )
              break
            case '016BS':
              newProductPackage = await addProductPackage(
                getBSCornMasaFlourPackage,
                'brandspecific/cornmasaflour',
                newProduct
              )
              break
            case '017BS':
              newProductPackage = await addProductPackage(
                getBSCornmealPackage,
                'brandspecific/cornmeal',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '50':
          switch (subCategory) {
            case '001':
            case '002':
              newProductPackage = await addProductPackage(
                getYogurtPackage,
                'yogurt',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '51':
          newProductPackage = await addProductPackage(
            getWholeMilkPackage,
            'milk',
            newProduct
          )
          break
        case '52':
          switch (subCategory) {
            case '002':
            case '004':
            case '006':
            case '012':
            case '014':
              newProductPackage = await addProductPackage(
                getFatReduceMilkPackage,
                'milk',
                newProduct
              )
              break
            case '011':
              newProductPackage = await addProductPackage(
                getPlantMilkPackage,
                'plantmilk',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '54':
          newProductPackage = await addProductPackage(
            getJuicePackage,
            'juice',
            newProduct
          )
          break
        case '19':
          if (subCategory === '001FF' || subCategory === '001FV') {
            newProductPackage = await addProductPackage(
              getFrozenVegFruitsPackage,
              'fruitsandvegetables/frozen',
              newProduct
            )
          } else if (subCategory === '001CF' || subCategory === '001CV') {
            newProductPackage = await addProductPackage(
              getCannedVegFruitsPackage,
              'fruitsandvegetables/canned',
              newProduct
            )
          } else if (subCategory === '004') {
            newProductPackage = await addProductPackage(
              getDriedFruitsPackage,
              'legumes',
              newProduct
            )
          }
          break

        default:
          console.log('newProduct Error: ' + JSON.stringify(newProduct))
      }

      let newProductImages = await addProductImages(
        newProductDescription?.pkProduct,
        newProduct?.images
      )

      const newProductTotal = {
        ...newProductDescription,
        ...newProductPackage,
        images: newProductImages,
      }
      console.log(
        'JSON.stringify(newProductTotal) after addProduct is: ' +
          JSON.stringify(newProductTotal)
      )
      dispatch({
        type: ADD_PRODUCT_SUBMIT,
        payload: newProductTotal,
      })
      console.log('Product successfully added')
      return newProductTotal
    } catch (err) {
      console.log('error: ' + JSON.stringify(err))
      if (err?.response?.status === 400) {
        notifyExistingUPC()
        console.log('checkExistingUPC didnt catch')
      }
      console.log('Add Product Error: ', JSON.stringify(err))
    }
  }

  // Update Product
  const updateSubmitterProduct = async newProduct => {
    try {
      console.log(
        'INSIDE updateSubmitterProduct -- JSON.stringify(newProduct) is: ' +
          JSON.stringify(newProduct)
      )
      const newproductWithoutReview = {
        ...newProduct,
        ReviewOneApproved: null,
        ReviewTwoApproved: null,
      }
      const newProductDescription = await updateProductDescription(
        newproductWithoutReview
      )

      let newProductPackage = null

      switch (newProduct?.fkCategory) {
        case '00':
          switch (newProduct?.fkSubCategory) {
            case '001':
              newProductPackage = await updateProductPackage(
                updatePlantYogurtPackage,
                'brandspecific/plantbasedyogurt',
                newProduct
              )
              break
            case '002':
              newProductPackage = await updateProductPackage(
                updatePlantCheesePackage,
                'brandspecific/plantbasedcheese',
                newProduct
              )
              break
            case '003':
              newProductPackage = await updateProductPackage(
                updateNutSeedButtersPackage,
                'brandspecific/nutandseedbutters',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '02':
          switch (newProduct?.fkSubCategory) {
            case '001':
              newProductPackage = await updateProductPackage(
                updateCheesePackage,
                'cheese',
                newProduct
              )
              break
            case '004':
              newProductPackage = await updateProductPackage(
                updateTofuPackage,
                'tofu',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '03':
          if (newProduct.fkSubCategory === '005')
            newProductPackage = await updateProductPackage(
              updateEggsPackage,
              'eggs',
              newProduct
            )
          break
        case '05':
          switch (newProduct?.fkSubCategory) {
            case '001BC':
              newProductPackage = await updateProductPackage(
                getBreakfastCerealPackage,
                'bsbreakfastcereal/breakfastcereal',
                newProduct
              )
              break
            case '001IO':
              newProductPackage = await updateProductPackage(
                getInstantOatmealPackage,
                'bsbreakfastcereal/instantoatmeal',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '06':
          newProductPackage = await updateProductPackage(
            updateLegumesPackage,
            'legumes',
            newProduct
          )
          break
        case '08':
          newProductPackage = await updateProductPackage(
            updateCannedFishPackage,
            'cannedfish',
            newProduct
          )
          break
        case '09':
          switch (newProduct?.fkSubCategory) {
            case '001BS':
              newProductPackage = await updateProductPackage(
                updateBSInfantCerealPackage,
                'brandspecific/infant/cereal',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '12':
          switch (newProduct?.fkSubCategory) {
            case '001':
            case '002':
            case '003':
            case '101':
            case '102':
            case '103':
              newProductPackage = await updateProductPackage(
                updateInfantFruitsAndVegsPackage,
                'infant/fruitsandvegetables',
                newProduct
              )
              break
            case '001BS':
            case '002BS':
            case '003BS':
            case '101BS':
            case '102BS':
            case '103BS':
              newProductPackage = await updateProductPackage(
                updateBSInfantFruitsAndVegsPackage,
                'brandspecific/infant/fruitsandvegetables',
                newProduct
              )
              break
            case '001RFI':
            case '002RFI':
            case '003RFI':
            case '101RFI':
            case '102RFI':
            case '103RFI':
              newProductPackage = await updateProductPackage(
                updateRFIInfantFruitsAndVegsPackage,
                'brandspecific/rfi/infant/fruitsandvegetables',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '13':
          switch (newProduct?.fkSubCategory) {
            case '001':
            case '101':
              newProductPackage = await updateProductPackage(
                updateInfantMeatsPackage,
                'infant/meats',
                newProduct
              )
              break
            case '001BS':
            case '101BS':
              newProductPackage = await updateProductPackage(
                updateBSInfantMeatsPackage,
                'brandspecific/infant/meats',
                newProduct
              )
              break
            case '001RFI':
            case '101RFI':
              newProductPackage = await updateProductPackage(
                updateRFIInfantMeatsPackage,
                'brandspecific/rfi/infant/meats',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '16':
          switch (newProduct?.fkSubCategory) {
            case '001':
            case '003':
            case '004':
            case '005':
            case '006':
              newProductPackage = await updateProductPackage(
                updateWholeGrainsPackage,
                'wholegrains',
                newProduct
              )
              break
            case '005BS':
              newProductPackage = await updateProductPackage(
                updateBSOatsOatmealPackage,
                'brandspecific/oatsoatmeal',
                newProduct
              )
              break
            case '007':
              newProductPackage = await updateProductPackage(
                updateCornTortillaPackage,
                'wholegrains/corntortilla',
                newProduct
              )
              break
            case '007BS':
              newProductPackage = await updateProductPackage(
                updateBSCornTortillaPackage,
                'bswholegrains/corntortilla',
                newProduct
              )
              break
            case '008':
              newProductPackage = await updateProductPackage(
                updateWheatTortillaPackage,
                'wholegrains/wheattortilla',
                newProduct
              )
              break
            case '008BS':
              newProductPackage = await updateProductPackage(
                updateBSWheatTortillaPackage,
                'bswholegrains/wheattortilla',
                newProduct
              )
              break
            case '009':
              newProductPackage = await updateProductPackage(
                updateWheatPastaPackage,
                'wholegrains/wheatpasta',
                newProduct
              )
              break
            case '009BS':
              newProductPackage = await updateProductPackage(
                updateBSWheatPastaPackage,
                'bswholegrains/wheatpasta',
                newProduct
              )
              break
            case '010BS':
              newProductPackage = await updateProductPackage(
                updateBSWholeWheatBagelsPackage,
                'brandspecific/wholewheatbagels',
                newProduct
              )
              break
            case '011BS':
              newProductPackage = await updateProductPackage(
                updateBSWholeWheatEnglishMuffinsPackage,
                'brandspecific/wholewheatenglishmuffins',
                newProduct
              )
              break
            case '012BS':
              newProductPackage = await updateProductPackage(
                updateBSWholeWheatPitaBreadPackage,
                'brandspecific/wholewheatpitabread',
                newProduct
              )
              break
            case '010':
              newProductPackage = await updateProductPackage(
                updateWWBagelsPackage,
                'wholewheatbagels',
                newProduct
              )
              break
            case '011':
              newProductPackage = await updateProductPackage(
                updateWWMuffinsPackage,
                'wholewheatmuffins',
                newProduct
              )
              break
            case '012':
              newProductPackage = await updateProductPackage(
                updateWWPitaBreadPackage,
                'wholewheatpitabread',
                newProduct
              )
              break
            case '013':
              newProductPackage = await updateProductPackage(
                updateBSWholeWheatNaanPackage,
                'brandspecific/wholewheatnaan',
                newProduct
              )
              break
            case '014':
              newProductPackage = await updateProductPackage(
                updateBSQuinoaPackage,
                'brandspecific/quinoa',
                newProduct
              )
              break
            case '015':
              newProductPackage = await updateProductPackage(
                updateBSWildRicePackage,
                'brandspecific/wildrice',
                newProduct
              )
              break
            case '016BS':
              newProductPackage = await updateProductPackage(
                updateBSCornMasaFlourPackage,
                'brandspecific/cornmasaflour',
                newProduct
              )
              break
            case '017BS':
              newProductPackage = await updateProductPackage(
                updateBSCornmealPackage,
                'brandspecific/cornmeal',
                newProduct
              )
              break
            case '016':
              newProductPackage = await updateProductPackage(
                updateCornMasaFlourPackage,
                'cornmasaflour',
                newProduct
              )
              break
            case '017':
              newProductPackage = await updateProductPackage(
                updateWGCornmealPackage,
                'wholegraincornmeal',
                newProduct
              )
              break
            default:
              break
          }

          break
        case '50':
          switch (newProduct?.fkSubCategory) {
            case '001':
            case '002':
              newProductPackage = await updateProductPackage(
                updateYogurtPackage,
                'yogurt',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '51':
          newProductPackage = await updateProductPackage(
            updateWholeMilkPackage,
            'milk',
            newProduct
          )
          break
        case '52':
          switch (newProduct?.fkSubCategory) {
            case '002':
            case '004':
            case '006':
            case '012':
            case '014':
              newProductPackage = await updateProductPackage(
                updateFatReduceMilkPackage,
                'milk',
                newProduct
              )
              break
            case '011':
              newProductPackage = await updateProductPackage(
                updatePlantMilkPackage,
                'plantmilk',
                newProduct
              )
              break
            default:
              break
          }
          break
        case '54':
          newProductPackage = await updateProductPackage(
            updateJuicePackage,
            'juice',
            newProduct
          )
          break
        case '19':
          if (
            newProduct.fkSubCategory === '001FF' ||
            newProduct.fkSubCategory === '001FV'
          ) {
            newProductPackage = await updateProductPackage(
              updateFrozenVegFruitsPackage,
              'fruitsandvegetables/frozen',
              newProduct
            )
          } else if (
            newProduct.fkSubCategory === '001CF' ||
            newProduct.fkSubCategory === '001CV'
          ) {
            newProductPackage = await updateProductPackage(
              updateCannedVegFruitsPackage,
              'fruitsandvegetables/canned',
              newProduct
            )
          } else if (newProduct.fkSubCategory === '004') {
            newProductPackage = await updateProductPackage(
              updateDriedFruitsPackage,
              'legumes',
              newProduct
            )
          }

          console.log('canned veg pack: ' + JSON.stringify(newProductPackage))
          break

        default:
          console.log('newProduct Error: ' + JSON.stringify(newProduct))
      }

      let updatedImages
      let addedImages

      if (newProduct?.images) {
        updatedImages = updateProductImages(
          newProduct?.images.filter(
            image => image.ProdImg && image.fkProduct !== 0
          )
        )
        addedImages = await addProductImages(
          newProduct?.pkProduct,
          newProduct?.images.filter(
            image => image.ProdImg && image.fkProduct === 0
          )
        )
        deleteProductImages(
          newProduct?.images.filter(
            image => image.fkProduct !== 0 && !image.ProdImg
          )
        )
      }

      const newProductTotal = {
        ...newProductDescription,
        ...newProductPackage,
      }

      if (updatedImages || addedImages) {
        newProductTotal.images = updatedImages + addedImages
      }

      dispatch({
        type: ADD_PRODUCT_SUBMIT,
        payload: newProductTotal,
      })
    } catch (err) {
      console.log('Add Product Error: ', JSON.stringify(err.response.data))
    }
  }

  // Filter
  const filterProducts = (validCategories, validSubCategories) => {
    dispatch({
      type: FILTER_PRODUCTS_SUBMIT,
      payload: { validCategories, validSubCategories },
    })
  }

  const setUpdate = value => {
    dispatch({ type: SET_UPDATE_SUBMIT, payload: value })
  }

  const setResetting = value => {
    dispatch({ type: SET_RESETTING_SUBMIT, payload: value })
  }

  const replaceProduct = async product => {
    product.category = product.fkCategory
    product.subCategory = product.fkSubCategory
    const convertedUPC = UPCE_to_UPCA(product.UPC)
    addProduct(product).then(async res => {
      console.log('addProduct res is: ' + JSON.stringify(res))
      if (res) {
        await deleteProduct(product, product.oldUPC)
        //await getVendorProducts(user?.fkVendor)
        await getContactProducts(user?.pkContact)
      }
    })
  }

  return (
    <SubmitContext.Provider
      value={{
        products: state.products,
        current: state.current,
        filtered: state.filtered,
        updating: state.updating,
        resetting: state.resetting,
        getVendorProducts,
        getContactProducts,
        deleteProduct,
        setCurrent,
        clearCurrent,
        notifyExistingUPC,
        checkUPCAddProduct,
        addProduct,
        editCurrent,
        updateSubmitterProduct,
        setUpdate,
        filterProducts,
        loadProductImages,
        UPCE_to_UPCA,
        setResetting,
        replaceProduct,
      }}
    >
      {/*Area where react-notification-alert will render*/}
      <NotificationAlert ref={notificationAlert} />
      {children}
    </SubmitContext.Provider>
  )
}

SubmitState.propTypes = {
  children: PropTypes.node,
}

export default SubmitState
